export default "__VITE_ASSET__BpKbxht___$_?url__"